import React, { useEffect, useState } from 'react';
import { makeApiRequest } from '../axiosService/apiCall';
import DataTable from 'react-data-table-component';
import config from "./config"
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
function AdminTransferHistory() {
    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [copiedValue, setCopiedValue] = useState('');
    const userData = async () => {
        try {
            let params = {
                url: `adminhistory`,
                method: 'GET',
            };
            let response = await makeApiRequest(params);

            if (response.status === true) {
                setData(response.data);
            } else {
                setData([]);
            }
        } catch (error) {
            // console.log('error', error);
        }
    };

    useEffect(() => {
        userData();
    }, []);

    const compressString = (str) => {
        return str.length > 10 ? `${str.slice(0, 6)}...${str.slice(-4)}` : str;
    };
    const formatISTDate = (dateString) => {

        if (!dateString) return "-";


        const date = new Date(dateString);

        return date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };
    const handleCopy = (value) => {
        setCopiedValue(value);
        setTimeout(() => setCopiedValue(''), 2000);
    };
    const columns = [
        { name: 'S.No', width: '100px', selector: (row) => row.sno },
        {
            name: 'Date',
            width: "350px",
            selector: row => row.date ? formatISTDate(row.date) : "-",
            cell: (row) => <div className="no-wrap-cell">{row.date ? formatISTDate(row.date) : "-"}</div>,
        },
        {
            name: 'Email',
            width: '200px',
            selector: (row) => row.email,
            cell: (row) => <div className="no-wrap-cell">{row.email}</div>,
        },
        {
            name: 'Coin',
            width: '100px',
            selector: (row) => row.symbol,
            cell: (row) => <div className="no-wrap-cell">{row.symbol}</div>,
        },
        {
            name: 'From Address',
            width: '150px',
            selector: (row) => row.fromAddress,
            cell: (row) => (
                <div className="no-wrap-cell">
                    {compressString(row.fromAddress)}
                    <CopyToClipboard className="ms-2" text={row.fromAddress} onCopy={() => handleCopy(row.fromAddress)}>
                        <FontAwesomeIcon icon={faCopy} />
                    </CopyToClipboard>
                </div>
            ),
        },
        {
            name: 'To Address',
            width: '150px',
            selector: (row) => row.toAddress,
            cell: (row) => (
                <div className="no-wrap-cell">
                    {compressString(row.toAddress)}
                    <CopyToClipboard className="ms-2" text={row.toAddress} onCopy={() => handleCopy(row.toAddress)}>
                        <FontAwesomeIcon icon={faCopy} />
                    </CopyToClipboard>
                </div>
            ),
        },
        {
            name: 'Transaction Hash',
            width: '250px',
            selector: (row) => row.txhash,
            cell: (row) => {
                const explorerUrl =
                    row.symbol === "TEXA"
                        ? `${config.TEXA_URL}${row.txhash}`
                        : `${config.BNB_URL}/tx/${row.txhash}`;

                return (
                    <div className="no-wrap-cell d-flex align-items-center gap-2">
                        <a href={explorerUrl} target="_blank" rel="noopener noreferrer">
                            {compressString(row.txhash)}
                        </a>
                        <CopyToClipboard className="ms-2" text={row.txhash} onCopy={() => handleCopy(row.txhash)}>
                            <FontAwesomeIcon icon={faCopy} style={{ cursor: 'pointer' }} />
                        </CopyToClipboard>
                    </div>
                );
            },
        },

        {
            name: 'Amount',
            width: '100px',
            selector: (row) => row.amount,
            cell: (row) => <div className="no-wrap-cell">{row.amount}</div>,
        },
    ];

    const customSort = (rows, selector, direction) => {
        return rows.sort((a, b) => {
            if (typeof selector(a) === "string") {
                const aField = selector(a).toLowerCase();
                const bField = selector(b).toLowerCase();

                let comparison = 0;

                if (aField > bField) {
                    comparison = 1;
                } else if (aField < bField) {
                    comparison = -1;
                }
                return direction === 'desc' ? comparison * -1 : comparison;
            } else {
                const aField = selector(a).props.children ? parseFloat(selector(a).props.children) : 0;
                const bField = selector(b).props.children ? parseFloat(selector(b).props.children) : 0;
                let comparison = 0;

                if (aField > bField) {
                    comparison = 1;
                } else if (aField < bField) {
                    comparison = -1;
                }
                return direction === 'desc' ? comparison * -1 : comparison;
            }
        });
    };

    const formattedData = data && Array.isArray(data) ? data.map((row, index) => ({
        sno: index + 1,
        _id: row._id,
        email: row.email ? row.email : "-",
        date: row.date ? row.date : "-",
        symbol: row.symbol ? row.symbol : "-",
        fromAddress: row.fromAddress ? row.fromAddress : "-",
        toAddress: row.toAddress ? row.toAddress : "-",
        txhash: row.txhash ? row.txhash : "-",
        amount: row.amount ? Number(row.amount).toFixed(6) : "-"

    })) : [];
    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setResetPaginationToggle(!resetPaginationToggle);
    };


    const filteredData = formattedData
        .filter(item => {
            const formattedDate = formatISTDate(item.date);
            const searchTermLower = searchTerm.toLowerCase();
            const isDateSearch = searchTermLower.match(/^(\d{4})-(\d{2})-(\d{2})$/);
            if (isDateSearch) {
                const dateMatch = formattedDate.toLowerCase().includes(searchTermLower);
                return dateMatch ||
                    item.email.toLowerCase().includes(searchTermLower) ||
                    item.symbol.toUpperCase().includes(searchTerm.toUpperCase()) ||
                item.fromAddress.includes(searchTerm) ||
                item.toAddress.includes(searchTerm) ||
                item.txhash.includes(searchTerm)

            }
            return (
                formattedDate.toLowerCase().includes(searchTermLower) ||
                item.email.toLowerCase().includes(searchTermLower) ||
                item.symbol.toUpperCase().includes(searchTerm.toUpperCase()) ||
            item.fromAddress.includes(searchTerm) ||
            item.toAddress.includes(searchTerm) ||
            item.txhash.includes(searchTerm)

            );
        })
        .map((item, index) => ({
            ...item,
            sno: index + 1
        }));



    return (
        <div className='App'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-12'>
                        <div className="custom-saled-order text-dark ms-3">
                            <div className="py-3 d-flex justify-content-between">
                                <h3 className="component-user">Admin Transfer History</h3>
                            </div>
                            <div>
                                <input
                                    type="text"
                                    placeholder="Search by Email"
                                    // style={{ "margin": "25px" }}
                                    value={searchTerm}
                                    onChange={handleSearch}
                                    className='form-search '
                                /> <br />
                                <div className='custom-datascroll'>
                                    {copiedValue && <div className="alert alert-success">Copied: {copiedValue}</div>}
                                    <DataTable
                                        className="text-center "
                                        columns={columns}
                                        data={filteredData}
                                        pagination
                                        persistTableHead
                                        sortFunction={customSort}
                                        paginationPerPage={5}
                                        paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                    />
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default AdminTransferHistory